import { formatPrice } from "utils";

const holder = {
  closeDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDropdownSelector)
    }
  }
};

export default {
  'Dropdown.Selector': async ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;

    await internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDropdownSelector);
    }
  },

  'Dropdown.Body.Option': ({ option }, outlet, internalStateSetter) => {
    outlet({ option })
    internalStateSetter('isOpen', false);
  },
  'Dropdown.Body.CustomOption': ({ option }, outlet, internalStateSetter) => {
    outlet({ option })
    internalStateSetter('isOpen', false);
  },
  'Dropdown.Selector.OptionsButton.Input': ({ selectedOption, selectedOptions, value }, outlet) => {
    let option = selectedOptions;
    let index = selectedOptions.findIndex(o => o.name === selectedOption.name);

    var count = (value.match(/\./g) || []).length;
    let maxLength = count === 0 ? 7 : 10;
    if (value.length > maxLength || count > 1) return;
    let val = value.replace(/[^\d.]/g, '');

    option[index].cost = formatPrice(val);
    outlet({ option })
  }
}